module.exports = __webpack_public_path__ + "assets/img/m.969345f3.png";